export const css = {
	root: '_1Oy8czfB',
	secondary: '_26PhoJ0y',
	required: 'rn_JUF0s',
	' _key': 'ascm-theme/ascm/dojo/label'
};

export default css;
